import { c as _c } from "react/compiler-runtime";
import { Dialog, TextField } from "@flat-ui";
import { UiUtils } from "@stellar/utils";
import { updateProjectDetails } from "@store/projects/projects-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { ChangeProjectDetailsEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useEffect, useState } from "react";
/**
 * Gets the description that should be displayed in the dialog.
 * If the description has a dash it means that it is empty, therefore
 * we should show the text field as empty.
 */
function getDisplayDescription(project) {
  if (project.description === UiUtils.DASH) {
    return "";
  }
  return project.description ?? "";
}

/**
 * Shows a text field and allow user to update the project description
 */
export function ProjectDescriptionModal(t0) {
  const $ = _c(23);
  const {
    project,
    isProjectEditable,
    shouldShowDialog,
    setShouldShowDialog
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== project) {
    t1 = getDisplayDescription(project);
    $[0] = project;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [description, setDescription] = useState(t1);
  let t2;
  if ($[2] !== project) {
    t2 = () => {
      setDescription(getDisplayDescription(project));
    };
    $[2] = project;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== project || $[5] !== shouldShowDialog) {
    t3 = [project, shouldShowDialog];
    $[4] = project;
    $[5] = shouldShowDialog;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== setShouldShowDialog) {
    t4 = function onClose() {
      setShouldShowDialog(false);
    };
    $[7] = setShouldShowDialog;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onClose = t4;
  const dispatch = useAppDispatch();
  let t5;
  if ($[9] !== description || $[10] !== dispatch || $[11] !== onClose || $[12] !== trackEvent) {
    t5 = () => {
      trackEvent({
        name: ChangeProjectDetailsEvents.changeProjectDescription,
        props: {
          newDescriptionLength: description.length
        }
      });
      dispatch(updateProjectDetails({
        payload: {
          description: description || UiUtils.DASH
        }
      }));
      onClose();
    };
    $[9] = description;
    $[10] = dispatch;
    $[11] = onClose;
    $[12] = trackEvent;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = description === project.description;
  let t7;
  if ($[14] !== description || $[15] !== isProjectEditable) {
    t7 = isProjectEditable ? <TextField autoFocus={true} placeholder="Add description..." text={description} fullWidth={true} multiline={true} onTextChanged={setDescription} rows={10} /> : <TextField variant="standard" readOnly={true} text={description} fullWidth={true} multiline={true} rows={10} controlStyle={{
      width: "530px"
    }} />;
    $[14] = description;
    $[15] = isProjectEditable;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== onClose || $[18] !== shouldShowDialog || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <Dialog open={shouldShowDialog} title="Description" onCancel={onClose} onConfirm={t5} confirmText="Done" isConfirmDisabled={t6}>{t7}</Dialog>;
    $[17] = onClose;
    $[18] = shouldShowDialog;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}